import { render, staticRenderFns } from "./ChangeOrderPhone.vue?vue&type=template&id=6b956ac0&scoped=true"
import script from "./ChangeOrderPhone.vue?vue&type=script&lang=js"
export * from "./ChangeOrderPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b956ac0",
  null
  
)

export default component.exports